/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-external-link': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" _fill="#fff" fill-rule="evenodd" d="M6.639.234A.798.798 0 017.204 0H11.2a.798.798 0 01.799.8v4a.8.8 0 01-1.365.566.8.8 0 01-.234-.566V2.731L5.37 7.766a.806.806 0 01-.878.184.811.811 0 01-.437-.437.826.826 0 01-.06-.31.824.824 0 01.245-.569L9.27 1.6H7.204A.798.798 0 016.639.234zM.469 2.87c.3-.3.706-.469 1.13-.469h2.398a.798.798 0 01.565 1.366.798.798 0 01-.565.234H1.599v6.4h6.394V8a.802.802 0 011.365-.566.8.8 0 01.234.566v2.4A1.6 1.6 0 017.994 12H1.598a1.598 1.598 0 01-1.599-1.6V4a1.6 1.6 0 01.468-1.131z" clip-rule="evenodd"/>'
  }
})
